import MemberRepository from '../repository/MemberRepository';

export default class MemberService {
    static avatarUrl(memberId, hasAvatar, gender, size, fileName, cacheBreaker) {
        if (!hasAvatar) {
            if (gender === 'gender.m') {
                return kgr.assetsUrls.avatarMale;
            } else if (gender === 'gender.f') {
                return kgr.assetsUrls.avatarFemale;
            }

            return kgr.assetsUrls.clubityAvatarUnknown;
        }

        return MemberRepository.avatarUrl(memberId, size, fileName, cacheBreaker);
    }
}
